import React from "react";

import { Input } from "../../../../../components/input";
import { Label } from "../../../../../components/label";
import { Textarea } from "../../../../../components/textarea";
import type { QuestionTypeRendererProps } from "./shared";

type TextQuestionType = "short_answer" | "long_answer";

type TextQuestionProps<TType extends TextQuestionType> = QuestionTypeRendererProps<TType> & {
  kind: TType;
};

export function TextQuestion<TType extends TextQuestionType>({
  question,
  isPreview,
  onUpdateQuestion,
  kind,
}: TextQuestionProps<TType>) {
  const data = question.data;
  const updateQuestionData = (updates: Partial<typeof data>) => {
    onUpdateQuestion({
      ...question,
      data: {
        ...data,
        ...updates,
      },
    });
  };

  if (isPreview) {
    return kind === "short_answer" ? (
      <Input placeholder="Short answer text" disabled />
    ) : (
      <Textarea placeholder="Long answer text" disabled />
    );
  }

  return (
    <div className="grid grid-cols-2 gap-4">
      <div>
        <Label>Min length</Label>
        <Input
          type="number"
          value={data.min_length || 0}
          onChange={(e) => updateQuestionData({ min_length: Number.parseInt(e.target.value, 10) || 0 })}
          className="mt-1"
        />
      </div>
      <div>
        <Label>Max length</Label>
        <Input
          type="number"
          value={data.max_length || 0}
          onChange={(e) => updateQuestionData({ max_length: Number.parseInt(e.target.value, 10) || 0 })}
          className="mt-1"
        />
      </div>
    </div>
  );
}

export default TextQuestion;
